var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { MultilineTextField } from "../components";
export const DescriptionTextField = (_a) => {
    var { name, label, subLabel, placeholder, rows } = _a, props = __rest(_a, ["name", "label", "subLabel", "placeholder", "rows"]);
    return (React.createElement(MultilineTextField, Object.assign({ optional: true, fullWidth: true }, props, { rows: rows ? rows : 5, name: name ? name : "description", label: label ? label : "Description", 
        // subLabel={subLabel ? subLabel : "(Optional)"}
        placeholder: placeholder ? placeholder : "Enter description" })));
};
//# sourceMappingURL=DescriptionTextField.js.map